const Pages = {
  Home: {
    path: "home",
    title: "Home",
    active: true,
  },
  Triagem: {
    path: "triagem",
    title: "Triagem",
    active: true,
  },
  Gestao: {
    path: "gestao",
    title: "Gestão",
    active: true,
  },
  Analise: {
    path: "analise",
    pageTitle: "Análise SKU",
    title: "SKU",
    active: false
  },
  Uploads: {
    path: "carga",
    title: "Upload de Arquivos",
    active: true,
    pageTitle: "Upload de Arquivos",
  },
  Reports: {
    path: "relatorios",
    title: "Requisição de Relatórios",
    active: true,
    pageTitle: "Relatórios",
  },
  TriangularOptimization: {
    path: "otimizacao-triangular",
    pageTitle: "Otimização Triangular",
    sidebarTitle: "Triangular",
    active: true,
  },
  HistoricalOptimization: {
    path: "otimizacao-historico",
    pageTitle: "Otimização por Histórico",
    sidebarTitle: "Histórico",
    active: true,
  },
  Relatorios: {
    path: "old-relatorios",
    title: "Histórico e Carga",
    active: false,
  },
  Configuracao: {
    path: "configuracao",
    title: "Configuração",
    active: true,
  },
};

export default Pages;
